import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ProductionPlans from "@/pages/ProductionPlans";
import ProductionCalendar from "@/pages/ProductionCalendar";
import ProductionBatches from "@/pages/ProductionBatches";
import ProductionVariance from "@/pages/ProductionVariance";

// Production module presented for desktop: the reference Production Plan page plus
// Calendar and Runs / Batches folded in as TABS of the same module. Same backend,
// same production logic — no separate production system.
export default function ProductionPlan() {
  const [tab, setTab] = useState("plans");
  return (
    <div className="space-y-4">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="production-tabs" className="bg-stone-100">
          <TabsTrigger value="plans" data-testid="production-tab-plans">Plans</TabsTrigger>
          <TabsTrigger value="calendar" data-testid="production-tab-calendar">Calendar</TabsTrigger>
          <TabsTrigger value="batches" data-testid="production-tab-batches">Runs / Batches</TabsTrigger>
          <TabsTrigger value="variance" data-testid="production-tab-variance">Variance</TabsTrigger>
        </TabsList>
        <TabsContent value="plans" className="mt-4"><ProductionPlans /></TabsContent>
        <TabsContent value="calendar" className="mt-4"><ProductionCalendar /></TabsContent>
        <TabsContent value="batches" className="mt-4"><ProductionBatches /></TabsContent>
        <TabsContent value="variance" className="mt-4"><ProductionVariance /></TabsContent>
      </Tabs>
    </div>
  );
}
